import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      paddingLeft: 15,
      paddingTop: 8,
      paddingBottom: 8,
      borderLeft: '1px dashed #a3a3a370',
      borderBottom: '1px dashed #afafaf70',
      color: 'white',
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      border: `1px solid ${theme.palette.secondary.main}`,
      borderRadius: 4,
    },
    expandButton: {
      minWidth: 25,
      maxWidth: 25,
      height: 20,

      padding: 2,
      margin: '0 8px 0 0',
      color: '#a3a3a3',
      borderColor: '#a3a3a3',
      '&:hover': {
        borderColor: '#fff',
        color: '#fff',
      },
    },
    eadItem: {
      backgroundColor: 'transparent',
      textOverflow: 'ellipsis',
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      padding: '0 2px',
    },
    active: {
      backgroundColor: theme.palette.primary.dark,
      color: 'white!important',
      padding: '0 2px',
    },
    link: {
      color: 'white',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    placeholder: {
      minWidth: 25,
      maxWidth: 25,
      padding: 2,
      margin: '0 8px 0 0',
    },
    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      marginRight: 4,
      fontSize: 13,
    },
    tooltip: {
      fontSize: 12,
    },
    buttonIcon: {
      '& > svg': {
        marginTop: '0.25rem',
        fontSize: '12px!important',
      },
    },
  })
);
